import { Box } from '@updater/ui-uds';
import { OrderSummary } from '../OrderSummary';
import { SupportInformation } from '../SupportInformation';
import { useIsIFramed } from 'hooks/useIsIFramed';

export const Aside = () => {
  const isIFramed = useIsIFramed();
  return (
    <Box>
      <OrderSummary />
      {!isIFramed && <SupportInformation />}
    </Box>
  );
};
